import React from "react";
import { Route, Routes } from "react-router-dom";
import NewEventPage from "./NewEventPage";
import EditEventPage from "./EditEventPage";
import ListEventPage from "./ListEventPage";
import ViewEventPage from "./ViewEventPage";

export default function EventPage() {
  return (
    <Routes>
      <Route path="/new" element={<NewEventPage />} />
      <Route path="/edit" element={<EditEventPage />} />
      <Route path="/list" element={<ListEventPage />} />
      <Route path="/view" element={<ViewEventPage />} />
    </Routes>
  );
}
